import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { toggleMute, leaveGroup } from '@/utils/SessionUtils';
import Dropdown from '../common/Dropdown';
import cssStyles from './Contacts.css';

function getRandomNumber() {
  return parseInt(Math.random() * 10000, 10);
}

export default class GroupContext extends Component {
  static defaultProps = {
    channelInfo: null,
  };

  static propTypes = {
    channelInfo: PropTypes.object,
  };

  componentDidMount() {
    this.dropdownRef = React.createRef();
    this.tabIndex = getRandomNumber();
  }

  onToggle = on => {
    console.log('reference of this', this);
    if (on) this.dropdownRef.current.focus();
  };

  toggleMute = () => {
    const { channelInfo } = this.props;
    toggleMute(channelInfo);
  };

  leaveChannel = () => {
    const { channelInfo } = this.props;
    leaveGroup(channelInfo);
  };

  preventPropagation = e => {
    if (e.target === this.dropdownRef.current) {
      e.stopPropagation();
    } else {
      return true;
    }
    return false;
  };

  render() {
    const { channelInfo } = this.props;
    if (!channelInfo) {
      return null;
    }
    const {
      name,
      isMuted,
      imageUrl,
      memberCount,
      hasMuteGroupPrivilege,
      hasLeaveGroupPrivilege,
    } = channelInfo;
    return (
      <Dropdown onToggle={this.onToggle}>
        {({ on, toggleOff, togglerProps }) => (
          <Fragment>
            <div {...togglerProps} className={cssStyles.context_menu_target} />
            {on ? (
              <div
                role='menuitem'
                onKeyDown={() => {}}
                className={cssStyles.context_dropdown}
                ref={this.dropdownRef}
                tabIndex={this.tabIndex}
                onClick={this.preventPropagation}
                onBlur={() => setTimeout(toggleOff, 500)}
              >
                <img src={imageUrl} alt={`${name} channel's thumbnail`} />
                <div className={cssStyles.channelName}>{name}</div>
                <div className={cssStyles.memberCount}>
                  {memberCount} Members
                </div>
                {hasMuteGroupPrivilege && (
                  <div
                    role='menuitem'
                    onKeyDown={() => {}}
                    tabIndex={0}
                    onClick={this.toggleMute}
                    className={classNames(cssStyles.button)}
                  >
                    {isMuted ? 'Unmute' : 'Mute'} Channel
                  </div>
                )}
                {hasLeaveGroupPrivilege && (
                  <div
                    role='menuitem'
                    onKeyDown={() => {}}
                    tabIndex={0}
                    onClick={this.leaveChannel}
                    className={classNames(cssStyles.button, cssStyles.red)}
                  >
                    Leave Channel
                  </div>
                )}
              </div>
            ) : null}
          </Fragment>
        )}
      </Dropdown>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/roster/GroupContext.js